var map = {
	"./symbol_0.png": "b8e7",
	"./symbol_1.png": "4b52",
	"./symbol_2.png": "9421",
	"./symbol_3.png": "cc81",
	"./symbol_4.png": "5819",
	"./symbol_5.png": "db7f",
	"./symbol_6.png": "3e82",
	"./symbol_7.png": "d03a",
	"./symbol_8.png": "5234"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ec04e";